'use client'

import { useMemo } from 'react'
import { useLanguage } from './providers/LanguageProvider'
import { buildTranslate } from './translate'
import { useTranslation as useReactI18NextTranslation } from 'react-i18next'

export const useTranslation = () => {
  const { lang } = useLanguage()
  const { i18n } = useReactI18NextTranslation('common')

  return useMemo(() => buildTranslate(lang, i18n), [i18n, lang])
}
